module.exports = __webpack_public_path__ + "static/img/rewards.b9843683.png";